if (!customElements.get('ap-product-details')) {
  customElements.define('ap-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [...this.querySelectorAll('[data-ap-tab]')];
      this.panels = [...this.querySelectorAll('[data-ap-panel]')];
      this.media = matchMedia('(min-width: 750px)');
      this.active = this.buttons[0]?.dataset.apTab;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => { this.active = button.dataset.apTab; this.render(); }, options);
        button.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          else if (event.key === 'ArrowLeft') next = (index + this.buttons.length - 1) % this.buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.buttons.length - 1;
          else return;
          event.preventDefault();
          this.active = this.buttons[next].dataset.apTab;
          this.render();
          this.buttons[next].focus();
        }, options);
      });
      this.media.addEventListener('change', () => this.render(), options);
      this.classList.add('is-ready');
      this.render();
    }
    disconnectedCallback() { this.events?.abort(); this.ready = false; }
    render() {
      this.buttons.forEach(button => {
        const active = button.dataset.apTab === this.active;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const active = panel.dataset.apPanel === this.active;
        panel.hidden = this.media.matches && !active;
        panel.open = this.media.matches || active;
        if (this.media.matches) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', `ap-tab-${panel.dataset.apPanel}`);
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
        }
      });
    }
  });
}
